<template>
  <div>
    <v-autocomplete
      hide-details
      outlined
      v-if="readonly === false"
      dense
      v-model="select"
      :items="Lista"
      item-text="descripcion_baja"
      item-value="id_motivo_baja"
      label="Motivo de baja"
      persistent-hint
      return-object
      @change="$emit('input', select.id_motivo_baja)"
    ></v-autocomplete>
    <v-text-field
      hide-details
      outlined
      dense
      label="Motivo de baja"
      v-if="readonly===true"
      filled
      readonly
      :value="select.descripcion_baja"
    ></v-text-field>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  props: {
    value: Number,
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    return {
      select: {
        id_motivo_baja: 0,
        descripcion_baja: ""
      }
    };
  },
  computed: {
    ...mapState("motivosdebaja", ["Lista"]),
  },
  methods: {
    seleccionar(id) {
      if (id != undefined) {
        let pr = this.Lista.find(x => x.id_motivo_baja == id);
        
        if (pr) {
          this.select = pr;
        } else {
          this.seleccionar("0");
        }
      }
    }
  },
  async mounted() {
    let id = this.value;
    this.seleccionar(id);
  },
  watch: {
    value: function(newVal, oldVal) {
      this.seleccionar(newVal);
    }
  }
};
</script>

<style>
</style>